import PropTypes from 'prop-types';
import styles from './Pagination.module.scss';
import classNames from 'classnames';
import ReactPaginate from 'react-paginate';

const Pagination = ({
    totalPages,
    currentPage,
    onPageChange,
}) => {
    return (
        <div className={styles['Pagination']}>
            <ReactPaginate
                forcePage={(currentPage - 1)}
                onPageChange={(e) => { onPageChange((e.selected + 1)) }}
                hrefAllControls={true}
                containerClassName={styles['Pagination__List']}
                pageClassName={styles['Pagination__Item']}
                pageLinkClassName={styles['Pagination__Link']}
                breakClassName={styles['Pagination__Break']}
                activeLinkClassName={classNames([styles['Pagination__Link'], styles['Pagination__Link--Active']])}
                previousLinkClassName={classNames([styles['Pagination__Link'], styles['Pagination__Link--Chevron'], styles['Pagination__Link--ChevronLeft']])}
                nextLinkClassName={classNames([styles['Pagination__Link'], styles['Pagination__Link--Chevron'], styles['Pagination__Link--ChevronRight']])}
                previousClassName={classNames([styles['Pagination__Item'], styles['Pagination__Item--Chevron'], styles['Pagination__Item--ChevronLeft']])}
                nextClassName={classNames([styles['Pagination__Item'], styles['Pagination__Item--Chevron'], styles['Pagination__Item--ChevronRight']])}
                disabledClassName={classNames([styles['Pagination__Item'], styles['Pagination__Link--Disabled']])}
                disabledLinkClassName={classNames([styles['Pagination__Link'], styles['Pagination__Link--Disabled']])}
                activeClassName={classNames([styles['Pagination__Item'], styles['Pagination__Item--Active']])}
                breakLabel="..."
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                pageCount={totalPages}
                previousLabel={null}
                nextLabel={null}
                renderOnZeroPageCount={null}
            />
        </div>
    );
};

Pagination.propTypes = {
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    onPageChange: PropTypes.func,
};

Pagination.defaultProps = {
    totalPages: 0,
    currentPage: 0,
};

export default Pagination;
